import { joinPath } from '@eventbrite/path-utils';
import { push } from 'react-router-redux';
import { Dispatch } from 'redux';
import { BASE_URL, CAPTCHA_ERROR_PATH } from '../../../constants';
import { CaptchaStatus } from '../../../models/app';
import { CheckoutState } from '../../../state';
import { setCaptchaV3StatusAction } from '../../app';
import { getIsUserGated } from '../../riskGate';
import { getEnableCaptchaAndRejectUser } from './getEnableCaptchaAndRejectUser';

export const shouldAbortOrderCreationAndRedirectToCaptchaError = async (
    dispatch: Dispatch<CheckoutState>,
    state: CheckoutState,
) => {
    const { rejectUser, enableCaptcha } = getEnableCaptchaAndRejectUser(state);
    if (rejectUser) {
        dispatch(push(joinPath(BASE_URL, CAPTCHA_ERROR_PATH)));
        return true;
    }

    if (enableCaptcha) {
        const shouldBlockUser = await getIsUserGated(state);
        dispatch(setCaptchaV3StatusAction(CaptchaStatus.refreshing));

        if (shouldBlockUser) {
            dispatch(push(joinPath(BASE_URL, CAPTCHA_ERROR_PATH)));
            return true;
        }
    }

    return false;
};
